import React, { useState } from 'react';
import { useNavigate } from 'react-router';
import { Upload, Plus } from 'lucide-react';
import { usePageConfig } from '../../contexts/PageConfigContext';
import { CustomersList } from './components/CustomersList';
import { CustomerExcelImport } from './components/CustomerExcelImport';
import { CustomerForm } from './components/CustomerForm';
import { Permissions } from '../../constants/permissions';

export const CustomersPage: React.FC = () => {
  const { setPageConfig } = usePageConfig();
  const navigate = useNavigate();
  
  // Dialog States
  const [showImportDialog, setShowImportDialog] = useState(false);
  const [showFormDialog, setShowFormDialog] = useState(false);
  const [selectedCustomerId, setSelectedCustomerId] = useState<string | null>(null);
  
  // List Refresh State
  const [refreshKey, setRefreshKey] = useState(0);

  const handleCreate = () => {
    setSelectedCustomerId(null);
    setShowFormDialog(true);
  };

  const handleEdit = (customerId: string) => {
    setSelectedCustomerId(customerId);
    setShowFormDialog(true);
  };

  const handleFormSuccess = () => {
    setShowFormDialog(false);
    setRefreshKey(prev => prev + 1);
  };

  React.useEffect(() => {
    setPageConfig({
      title: 'Clientes',
      actions: [
        {
          label: 'Importar',
          icon: Upload,
          onClick: () => setShowImportDialog(true),
          variant: 'secondary' as const,
          permission: Permissions.Items.Create,
          iconOnly: true,
          tooltip: 'Importar desde Excel'
        },
        {
          label: 'Nuevo Cliente',
          icon: Plus,
          onClick: handleCreate,
          variant: 'primary' as const
        }
      ]
    });
  }, [setPageConfig]);

  return (
    <div className="w-full">
      <CustomersList 
        key={refreshKey} 
        onEdit={handleEdit} 
        onDelete={() => setRefreshKey(prev => prev + 1)} 
      />
      
      {/* Import Dialog */}
      <CustomerExcelImport
        isOpen={showImportDialog}
        onClose={() => setShowImportDialog(false)}
        onSuccess={() => setRefreshKey(prev => prev + 1)}
      />

      {/* Create/Edit Form Dialog (Integrated) */}
      <CustomerForm
        isOpen={showFormDialog}
        onOpenChange={setShowFormDialog}
        customerId={selectedCustomerId}
        onSuccess={handleFormSuccess}
      />
    </div>
  );
};
